import React from "react";
import "../../../css/BoletinOficial/declaraciones.css";
import IframePage from "../BoletinOFicial/IframePage";

const ProyectosPresentados = () => (
  <IframePage
    title="PROYECTOS PRESENTADOS"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/noticias/archivos-convencion-municipal"
    classPrefix="declaraciones"
  />
);

export default ProyectosPresentados;